import { Injectable } from '@angular/core';

export interface ToastMessage {
  id: number;
  message: string;
  type: 'success' | 'error';
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: ToastMessage[] = [];
  private nextId = 0;

  show(message: string, type: 'success' | 'error' = 'success'): void {
    this.toasts.push({ id: this.nextId++, message, type });
  }

  success(message: string): void {
    this.show(message, 'success');
  }

  error(message: string): void {
    this.show(message, 'error');
  }

  remove(toast: ToastMessage): void {
    this.toasts = this.toasts.filter((t) => t.id !== toast.id);
  }
}
